import { useData } from 'context/data.context';
import { CLASS_LABELS } from 'utilities/global.variables';
import TableCard from '../cards/table.card';

const PortfolioPanel = ({ onItemClick }) => {
  const { networthCurrent, networthProjected } = useData();

  return (
    <>
      <div className='Assets light'>
        <div className="flex col large-gap">
          <p className='xlarge padding'>Asset forecast</p>
          {networthCurrent.assets.classes.map(({ name, items }) => (
            <TableCard key={name} isAsset classification={CLASS_LABELS[name] ?? name} years={networthProjected.years} items={items} onItemClick={(item) => onItemClick(item, 'Assets')} />
          ))}
        </div>
      </div>

      <div className='Liabilities light'>
        <div className="flex col large-gap">
          <p className='xlarge padding'>Liability forecast</p>
          {networthCurrent.liabilities.classes.map(({ name, items }) => (
            <TableCard key={name} isLiability classification={name} years={networthProjected.years} items={items} onItemClick={(item) => onItemClick(item, 'Liabilities')} />
          ))}
        </div>
      </div>
    </>
  );
};

export default PortfolioPanel;
